export const getWebsocketEndpoint = ({ clientId, userId }: { clientId: number; userId: number }) =>
  import.meta.env.VITE_WEBSOCKET_ENDPOINT + `/ws/v1/insights/${clientId}/${userId}`;
